import React from 'react';
import ReactPlayer from 'react-player';

const Streamable = () => {
  return <ReactPlayer controls={true} url='https://streamable.com/moo' />;
};

export default Streamable;
